import icon from 'vue-svgicon';

icon.register({
    'regular/walking': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<circle pid="0" cx="11.099" cy="3.554" r="2.625" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" d="M18.151 11.8a2.238 2.238 0 0 1-1.756-.843 7.7 7.7 0 0 0-6.046-2.907 6.006 6.006 0 0 0-6 6 1.5 1.5 0 0 0 3 0 3.006 3.006 0 0 1 2.25-2.9v.5a16.317 16.317 0 0 1-2.748 9.076 1.5 1.5 0 1 0 2.5 1.664A19.4 19.4 0 0 0 11.6 17.8a8.038 8.038 0 0 1 3.329 4.233 1.5 1.5 0 1 0 2.844-.949 11.038 11.038 0 0 0-5.425-6.307 19.381 19.381 0 0 0 .253-3.127v-.03a4.729 4.729 0 0 1 1.453 1.214 5.222 5.222 0 0 0 4.1 1.97 1.5 1.5 0 0 0 0-3z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
